/**
 * This file is copied from the publishing-api generated types file in the buffer
 * mono repo (services/publishing/publishing-api/src/types/graphql/generated.types.ts).
 * Please keep this file in sync until we can migrate Publish to the mono repo.
 */

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AddCommentInput = {
  postId: Scalars['String'];
  text: Scalars['String'];
  type: CommentType;
};

export type AddCommentPayload = {
  __typename?: 'AddCommentPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type Calendar = {
  __typename?: 'Calendar';
  campaigns?: Maybe<Array<PublishingCampaign>>;
  days?: Maybe<Array<Maybe<CalendarDay>>>;
  posts: Array<Maybe<PublishingPost>>;
};

export type CalendarDay = Day & {
  __typename?: 'CalendarDay';
  /** The start timestamp of the day in seconds */
  startTimestamp: Scalars['Int'];
  /** The day of the week, e.g., 'Monday' */
  dayName: DayName;
  /** The numerical day of the month, e.g., 31 */
  dayOfMonth: Scalars['Int'];
  /** The name of the month, e.g., 'January' */
  monthName: MonthName;
  /** A list of campaigns present on the requested day */
  campaigns?: Maybe<Array<PublishingCampaign>>;
  /** A collection of time spans for the given day which may contain posts */
  intervals?: Maybe<Array<CalendarInterval>>;
  /** A list of posts for the given day */
  posts?: Maybe<Array<PublishingPost>>;
  /** The number of posts for the given day */
  counts?: Maybe<Array<PostServiceCount>>;
};

export type CalendarInput = {
  /** The start date of posts to return, a unix timestamp (in seconds) */
  startDate: Scalars['Int'];
  /** The oldest date of posts to return, a unix timestamp (in seconds) */
  endDate: Scalars['Int'];
  /** The channel(s) to fetch posts for */
  channelIds?: Maybe<Array<Scalars['ID']>>;
  /** The campaign(s) to fetch posts for */
  campaignIds?: Maybe<Array<Scalars['ID']>>;
  /** The span of time for each group of posts */
  intervalSize?: Maybe<IntervalSize>;
  /** Whether to return date/time strings in 24 hour time format */
  use24HourTime?: Maybe<Scalars['Boolean']>;
  /** The timezone to use for formatting dates and times */
  timezone: Scalars['String'];
  /** Whether or not to include posts with status set to 'draft' */
  includeDrafts?: Maybe<Scalars['Boolean']>;
  /** MOCK MODE ONLY: Seed value for random generator */
  _seed?: Maybe<Scalars['Int']>;
};

/**
 * Represents a span of time in the calendar which may or may not contain post items.
 * The length of the interval is configured by the intervalLength passed to the query.
 */
export type CalendarInterval = {
  __typename?: 'CalendarInterval';
  /** A human readable label for the start of the interval, e.g., '2 PM' or '14:00' */
  label: Scalars['String'];
  /** A unix timestamp representing the beginning of the interval */
  startTimestamp: Scalars['Int'];
  /** A list of posts within this interval */
  posts?: Maybe<Array<PublishingPost>>;
};

export type CalendarsPayload = Calendar | PublishingError;

export type Campaigns = {
  __typename?: 'Campaigns';
  /** A list of campaigns belonging to the user's current organization */
  campaigns?: Maybe<Array<PublishingCampaign>>;
};

export type CampaignsListInput = {
  /** The timezone to use for formatting dates and times */
  timezone: Scalars['String'];
  /** MOCK MODE ONLY: Seed value for random generator */
  _seed?: Maybe<Scalars['Int']>;
};

export type CampaignsPayload = Campaigns | PublishingError;

export type ChannelData = {
  __typename?: 'ChannelData';
  googlebusiness?: Maybe<GoogleBusinessData>;
  instagram?: Maybe<InstagramData>;
  startPage?: Maybe<StartPageData>;
  youtube?: Maybe<YoutubeData>;
};

export type ChannelLocationData = {
  __typename?: 'ChannelLocationData';
  location?: Maybe<Scalars['String']>;
  mapsLink?: Maybe<Scalars['String']>;
};

/** Query responses */
export type Checklist = {
  __typename?: 'Checklist';
  id: Scalars['Int'];
  title: Scalars['String'];
  items?: Maybe<Array<Maybe<ChecklistItem>>>;
};

export type ChecklistItem = {
  __typename?: 'ChecklistItem';
  id: Scalars['Int'];
  description: Scalars['String'];
  isCompleted: Scalars['Boolean'];
};

export type ChecklistsPayload = ChecklistsResponse | CoreWebAppCommonError;

export type ChecklistsResponse = {
  __typename?: 'ChecklistsResponse';
  checklists?: Maybe<Array<Maybe<Checklist>>>;
};

export enum CommentType {
  Comment = 'COMMENT',
  History = 'HISTORY',
}

/** Common error type to be used whenever no custom Error type needs to be created */
export type CoreWebAppCommonError = CoreWebAppError & {
  __typename?: 'CoreWebAppCommonError';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String'];
  /** A raw error message to describe the error to the client. Should not be displayed to customers. */
  error: Scalars['String'];
};

/** Base error interface used to implement custom error types */
export type CoreWebAppError = {
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String'];
  /** A raw error message to describe the error to the client. Should not be displayed to customers. */
  error: Scalars['String'];
};

/** Base mutation response interface used to implement custom mutation response types */
export type CoreWebAppMutationResponse = {
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String'];
};

export type Day = {
  startTimestamp: Scalars['Int'];
  dayName: DayName;
  dayOfMonth: Scalars['Int'];
  monthName: MonthName;
  campaigns?: Maybe<Array<PublishingCampaign>>;
};

export enum DayName {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
}

export type DeleteCommentInput = {
  postId: Scalars['String'];
  commentId: Scalars['String'];
};

export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeletePostInput = {
  postId: Scalars['String'];
};

export type FilterBy = {
  by: Scalars['String'];
  value: Scalars['String'];
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type GoogleBusinessData = {
  __typename?: 'GoogleBusinessData';
  /** @deprecated Use updateType field on PublishingPost */
  post_type: Scalars['String'];
  start_date?: Maybe<Scalars['Int']>;
  end_date?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['String']>;
  end_time?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
};

export type HexColor = {
  __typename?: 'HexColor';
  value?: Maybe<Scalars['String']>;
};

export type Idea = {
  __typename?: 'Idea';
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  content: IdeaContent;
  createdAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type IdeaContent = {
  __typename?: 'IdeaContent';
  text?: Maybe<Scalars['String']>;
  media?: Maybe<Array<IdeaMedia>>;
};

export type IdeaContentInput = {
  text?: Maybe<Scalars['String']>;
  media?: Maybe<Array<IdeaMediaInput>>;
};

export type IdeaCreationInput = {
  organizationId: Scalars['String'];
  content: IdeaContentInput;
  source?: Maybe<Scalars['String']>;
};

export type IdeaEdge = {
  __typename?: 'IdeaEdge';
  node: Idea;
  cursor: Scalars['String'];
};

export type IdeaIdInput = {
  id: Scalars['String'];
};

export type IdeaMedia = {
  __typename?: 'IdeaMedia';
  /** The upload id */
  id: Scalars['ID'];
  url: Scalars['String'];
  alt?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  type: MediaType;
  size?: Maybe<Scalars['Int']>;
  source?: Maybe<IdeaMediaSource>;
};

export type IdeaMediaInput = {
  /** The upload id */
  id: Scalars['ID'];
  url: Scalars['String'];
  alt?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  type: MediaType;
  size?: Maybe<Scalars['Int']>;
  source?: Maybe<IdeaMediaSourceInput>;
};

/** Output Types */
export type IdeaMediaSource = {
  __typename?: 'IdeaMediaSource';
  name: Scalars['String'];
  id: Scalars['String'];
  /** for unsplash only */
  author?: Maybe<Scalars['String']>;
  authorUrl?: Maybe<Scalars['String']>;
};

export type IdeaMediaSourceInput = {
  name: MediaSourceName;
  id: Scalars['String'];
  /** for unsplash only */
  author?: Maybe<Scalars['String']>;
  authorUrl?: Maybe<Scalars['String']>;
};

export type IdeaMutationPayload = IdeaMutationSuccess | CoreWebAppCommonError;

export type IdeaMutationSuccess = CoreWebAppMutationResponse & {
  __typename?: 'IdeaMutationSuccess';
  code: Scalars['String'];
  success: Scalars['Boolean'];
  message: Scalars['String'];
  /** The created ideas */
  idea: Idea;
};

export type IdeaPayload = Idea | CoreWebAppCommonError;

export type IdeasCount = {
  __typename?: 'IdeasCount';
  count: Scalars['Int'];
};

export type IdeasCountPayload = IdeasCount | CoreWebAppCommonError;

export type IdeasDeletionInput = {
  ids: Array<Scalars['String']>;
};

export type IdeasDeletionPayload = IdeasDeletionSuccess | CoreWebAppCommonError;

export type IdeasDeletionSuccess = CoreWebAppMutationResponse & {
  __typename?: 'IdeasDeletionSuccess';
  code: Scalars['String'];
  success: Scalars['Boolean'];
  message: Scalars['String'];
  /** The deleted ideas */
  ideas: Array<Idea>;
};

export type IdeasListInput = {
  organizationId: Scalars['String'];
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  filter?: Maybe<FilterBy>;
  order?: Maybe<OrderBy>;
};

export type IdeaUpdateInput = {
  id: Scalars['String'];
  content: IdeaContentInput;
};

export type InstagramData = {
  __typename?: 'InstagramData';
  /** @deprecated Use updateType field on PublishingPost */
  post_type: Scalars['String'];
};

export enum IntervalSize {
  ThirtyMinutes = 'thirtyMinutes',
  OneHour = 'oneHour',
  TwoHours = 'twoHours',
}

export enum MediaSourceName {
  Canva = 'canva',
  Unsplash = 'unsplash',
}

export enum MediaType {
  Image = 'image',
  Gif = 'gif',
  Video = 'video',
  Link = 'link',
}

export enum MonthName {
  January = 'January',
  February = 'February',
  March = 'March',
  April = 'April',
  May = 'May',
  June = 'June',
  July = 'July',
  August = 'August',
  September = 'September',
  October = 'October',
  November = 'November',
  December = 'December',
}

export type Mutation = {
  __typename?: 'Mutation';
  createTestIdeas: PlaceholderIdeasCreatedPayload;
  deletePost: PostDeletionPayload;
  /** @todo: change response to use the generic PostUpdatedPayload */
  updatePostDueAt: UpdatePostDueAtMutationResponse;
  movePostToDrafts: PostUpdatedPayload;
  ideasRemove: IdeasDeletionPayload;
  addCommentToUpdate: AddCommentPayload;
  deleteCommentInUpdate: DeleteCommentPayload;
  ideaCreate: IdeaMutationPayload;
  ideaUpdate: IdeaMutationPayload;
};

export type MutationCreateTestIdeasArgs = {
  input: TestIdeasInput;
};

export type MutationDeletePostArgs = {
  input: DeletePostInput;
};

export type MutationUpdatePostDueAtArgs = {
  input: UpdatePostDueAtInput;
};

export type MutationMovePostToDraftsArgs = {
  input: PostIdInput;
};

export type MutationIdeasRemoveArgs = {
  input: IdeasDeletionInput;
};

export type MutationAddCommentToUpdateArgs = {
  input: AddCommentInput;
};

export type MutationDeleteCommentInUpdateArgs = {
  input: DeleteCommentInput;
};

export type MutationIdeaCreateArgs = {
  input: IdeaCreationInput;
};

export type MutationIdeaUpdateArgs = {
  input: IdeaUpdateInput;
};

export type OrderBy = {
  by: Scalars['String'];
  value: Scalars['String'];
};

export type OrganizationIdInput = {
  organizationId: Scalars['String'];
};

export type PaginatedIdeasList = {
  __typename?: 'PaginatedIdeasList';
  edges: Array<Maybe<IdeaEdge>>;
  pageInfo: PaginationPageInfo;
};

export type PaginatedIdeasPayload = PaginatedIdeasList | CoreWebAppCommonError;

export type PaginationPageInfo = {
  __typename?: 'PaginationPageInfo';
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
  hasPreviousPage: Scalars['Boolean'];
  hasNextPage: Scalars['Boolean'];
};

export type PlaceholderIdeasCreatedPayload =
  | PlaceholderIdeasMutationSuccess
  | CoreWebAppCommonError;

/** Query / Mutation responses */
export type PlaceholderIdeasMutationSuccess = CoreWebAppMutationResponse & {
  __typename?: 'PlaceholderIdeasMutationSuccess';
  code: Scalars['String'];
  success: Scalars['Boolean'];
  message: Scalars['String'];
  /** The created ideas */
  ideas: Array<Idea>;
};

export type PostDeletionPayload = PostDeletionResponse | PublishingError;

export type PostDeletionResponse = {
  __typename?: 'PostDeletionResponse';
  success?: Maybe<Scalars['Boolean']>;
  postId: Scalars['String'];
};

export type PostIdInput = {
  postId: Scalars['String'];
};

export type PostNotFound = CoreWebAppMutationResponse & {
  __typename?: 'PostNotFound';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String'];
  /** The ID of the post that could not be found */
  postId: Scalars['String'];
};

export type PostNotUpdated = CoreWebAppMutationResponse & {
  __typename?: 'PostNotUpdated';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String'];
  /** The ID of the post that could not be found */
  postId: Scalars['String'];
};

/** Represents the number of posts for a service during some span of time */
export type PostServiceCount = {
  __typename?: 'PostServiceCount';
  service: Service;
  value: Scalars['Int'];
  hasAutoApprovedDrafts: Scalars['Boolean'];
  hasDraftsAwaitingApproval: Scalars['Boolean'];
};

export type PostStatistics = {
  __typename?: 'PostStatistics';
  retweets?: Maybe<Scalars['Int']>;
  reach?: Maybe<Scalars['Int']>;
  favorites?: Maybe<Scalars['Int']>;
  likes?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['Int']>;
  clicks?: Maybe<Scalars['Int']>;
  reach_twitter?: Maybe<Scalars['Int']>;
  shares?: Maybe<Scalars['Int']>;
  reshares?: Maybe<Scalars['Int']>;
  repins?: Maybe<Scalars['Int']>;
  mentions?: Maybe<Scalars['Int']>;
  linkClicks?: Maybe<Scalars['Int']>;
};

export type PostUpdated = CoreWebAppMutationResponse & {
  __typename?: 'PostUpdated';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code: Scalars['String'];
  /** A boolean representing success of the entire mutation */
  success: Scalars['Boolean'];
  /** A user friendly message to describe the status to the client */
  message: Scalars['String'];
  /** The updated post */
  post: PublishingPost;
};

export type PostUpdatedPayload =
  | PostUpdated
  | PostNotFound
  | PostNotUpdated
  | CoreWebAppCommonError;

export type PublishingCampaign = {
  __typename?: 'PublishingCampaign';
  id: Scalars['ID'];
  color: HexColor;
  name: Scalars['String'];
  startDate?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Int']>;
  /** Human readable date of campaign. E.g., 'Oct 11-13' */
  formattedDateRange?: Maybe<Scalars['String']>;
};

export type PublishingChannel = {
  __typename?: 'PublishingChannel';
  id: Scalars['ID'];
  service: Service;
  username: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  serverUrl?: Maybe<Scalars['String']>;
  locationData?: Maybe<ChannelLocationData>;
};

export type PublishingError = {
  __typename?: 'PublishingError';
  /** A code to describe the status eg 200 for success, 404 for not found */
  code?: Maybe<Scalars['String']>;
  /** A user-friendly message that is safe to be displayed to users. */
  userFriendlyMessage: Scalars['String'];
  /** A raw error message to help developpers understand the root cause of the issue. */
  cause: Scalars['String'];
};

export type PublishingPost = {
  __typename?: 'PublishingPost';
  id: Scalars['ID'];
  /** The type of post, always 'post' for now, but could be 'story' in a future version */
  type: PublishingPostType;
  /** The channel to which this post will be (or is) published */
  channel: PublishingChannel;
  /** The subprofile is currently only used for Pinterest Boards */
  subprofile?: Maybe<PublishingSubprofile>;
  /** The campaign this post is associated with */
  campaign?: Maybe<PublishingCampaign>;
  /** Attachments such as retweet, link, etc. for this post */
  attachments?: Maybe<Array<Maybe<PublishingPostAttachment>>>;
  /** Media items (images, videos) attached to this post */
  media?: Maybe<Array<PublishingPostMedia>>;
  /** The current state of the post */
  status: PublishingPostStatus;
  /** Details of the post error, if present */
  error?: Maybe<PublishingPostError>;
  /** The text content of the post */
  text?: Maybe<Scalars['String']>;
  /** A human readable timestamp of when the post is (or will be) sent, e.g., '2:10 PM' or '14:10' */
  formattedTime?: Maybe<Scalars['String']>;
  /** Whether this post is (or will be) sent as an Instagram reminder */
  isReminder: Scalars['Boolean'];
  /** Whether this post is (or was) scheduled for a specific date and time */
  isCustomScheduled: Scalars['Boolean'];
  /** Whether this post is (or was) specifically scheduled into one of the channel's schedule time slots */
  isPinned: Scalars['Boolean'];
  /** Whether this post is a retweet */
  isRetweet: Scalars['Boolean'];
  /** The unix timestamp of when the post was (or will be) sent */
  dueAt: Scalars['Int'];
  /** Post analytics */
  statistics?: Maybe<PostStatistics>;
  /** The post title, this is currently only used for Pinterest */
  title?: Maybe<Scalars['String']>;
  /** The location for the post */
  geoLocation?: Maybe<GeoLocation>;
  /** Id of the user who created the post */
  createdBy: Scalars['ID'];
  /** Whether a post needs approval before being scheduled */
  needsApproval?: Maybe<Scalars['Boolean']>;
  /** Pinterest source url */
  sourceUrl?: Maybe<Scalars['String']>;
  /** Channel specific data */
  channelData?: Maybe<ChannelData>;
  /** Type of the update (e.g. Reel or Feed for IG) */
  updateType?: Maybe<Scalars['String']>;
  /** Flag to check if the post was created via Blueprints */
  isBlueprint?: Maybe<Scalars['Boolean']>;
  /** Number of threaded updates, including the parent update */
  threadCount?: Maybe<Scalars['Int']>;
  /** The direct URL to the post */
  serviceLink?: Maybe<Scalars['String']>;
};

export type PublishingPostAttachment =
  | PublishingPostRetweet
  | PublishingPostLink
  | PublishingPostDestinationUrl
  | PublishingPostFirstComment;

export type PublishingPostDestinationUrl = {
  __typename?: 'PublishingPostDestinationUrl';
  url: Scalars['String'];
};

export type PublishingPostError = {
  __typename?: 'PublishingPostError';
  message: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  actionType?: Maybe<PublishingPostErrorAction>;
  rawError?: Maybe<Scalars['String']>;
};

export enum PublishingPostErrorAction {
  Refresh = 'refresh',
}

export type PublishingPostFirstComment = {
  __typename?: 'PublishingPostFirstComment';
  text: Scalars['String'];
};

export type PublishingPostLink = {
  __typename?: 'PublishingPostLink';
  url: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type PublishingPostMedia = {
  __typename?: 'PublishingPostMedia';
  original: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
  type: MediaType;
};

export type PublishingPostRetweet = {
  __typename?: 'PublishingPostRetweet';
  /** The tweet url */
  url: Scalars['String'];
  /** The unix timestamp of when the tweet was sent to retweets */
  sentAt: Scalars['Int'];
  avatar?: Maybe<Scalars['String']>;
  accountName: Scalars['String'];
  username: Scalars['String'];
  text: Scalars['String'];
};

export enum PublishingPostStatus {
  Pending = 'pending',
  Sent = 'sent',
  Error = 'error',
  PendingTiktok = 'pending_tiktok',
}

export enum PublishingPostType {
  Post = 'post',
  Story = 'story',
  Draft = 'draft',
}

export type PublishingSubprofile = {
  __typename?: 'PublishingSubprofile';
  id: Scalars['ID'];
  userId: Scalars['ID'];
  channelId: Scalars['ID'];
  avatar?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
  service: Scalars['String'];
  layout?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  isShared: Scalars['Boolean'];
  createdAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PusherAuth = {
  __typename?: 'PusherAuth';
  auth?: Maybe<Scalars['String']>;
};

export type PusherAuthenticationInput = {
  socketId: Scalars['String'];
  pusherChannel: Scalars['String'];
  organizationId: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  calendar?: Maybe<CalendarsPayload>;
  pusherAuthentication: PusherAuth;
  ideas: PaginatedIdeasPayload;
  idea?: Maybe<IdeaPayload>;
  ideasCount: IdeasCountPayload;
  checklists: ChecklistsPayload;
};

export type QueryCalendarArgs = {
  input?: Maybe<CalendarInput>;
};

export type QueryPusherAuthenticationArgs = {
  input: PusherAuthenticationInput;
};

export type QueryIdeasArgs = {
  input: IdeasListInput;
};

export type QueryIdeaArgs = {
  input: IdeaIdInput;
};

export type QueryIdeasCountArgs = {
  input: OrganizationIdInput;
};

export type QueryChecklistsArgs = {
  input: OrganizationIdInput;
};

export enum Service {
  Instagram = 'instagram',
  Facebook = 'facebook',
  Twitter = 'twitter',
  Linkedin = 'linkedin',
  Pinterest = 'pinterest',
  Shopify = 'shopify',
  Tiktok = 'tiktok',
  Googlebusiness = 'googlebusiness',
  StartPage = 'startPage',
  Mastodon = 'mastodon',
  Youtube = 'youtube',
}

export type StartPageData = {
  __typename?: 'StartPageData';
  link?: Maybe<Scalars['String']>;
};

/** Input Types */
export type TestIdeasInput = {
  organizationId: Scalars['String'];
  number?: Maybe<Scalars['Int']>;
};

export type UpdatePostDueAtInput = {
  postId: Scalars['String'];
  timestamp: Scalars['Int'];
};

/** @deprecated: use the generic PostUpdatedPayload */
export type UpdatePostDueAtMutationResponse =
  | PostUpdated
  | PostNotFound
  | PostNotUpdated
  | CoreWebAppCommonError;

export type YoutubeData = {
  __typename?: 'YoutubeData';
  title?: Maybe<Scalars['String']>;
};
